var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"listexternal"}},[(!_vm.loading)?_c('list-export',{attrs:{"list-result-prop":_vm.listResult}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }